import { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './Pages/Front-Pages/Home';
import CreateShelf from './Pages/Front-Pages/Shelfs/CreateShelf';
import CreatePage from './Pages/Front-Pages/Page/CreatePage';
import ShelvePageList from './Pages/Front-Pages/Shelfs/ShelvePageList';
import PageContent from './Pages/Front-Pages/Page/PageContent';
import EditPage from './Pages/Front-Pages/Page/EditPage';
import { ToastContainer, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import EditShelve from './Pages/Front-Pages/Shelfs/EditShelve';
import { BreadcrumbProvider } from './Utilities/Breadscrumb/BreadcrumbContext';
import StackLayout from './Pages/Front-Pages/inc/Layout copy';
import TagPages from './Pages/Front-Pages/Tags/TagPages';
import Login from './Pages/Front-Pages/Auth/Login';
import axios from "./interseptor/axiosConf";
import Test from './Pages/Front-Pages/inc/Test';
import GlobalSpinner from './Utilities/GlobleSpinner';

function App() {
  const [isCSRFTokenLoaded, setIsCSRFTokenLoaded] = useState(false);

  localStorage.setItem('BE_Domain', 'https://be.stacktest.sbs');
  // localStorage.setItem('BE_Domain', 'http://be.stack.local');

  localStorage.setItem("BeURL", 'https://be.stacktest.sbs/api/');

  useEffect(() => {
    const fetchCSRFToken = async () => {
      try {
        await axios.get('/sanctum/csrf-cookie'); 
        console.log('CSRF token set');
        setIsCSRFTokenLoaded(true); // Set state to true once token is fetched
      } catch (error) {
        console.error('Error fetching CSRF token:', error);
      }
    };

    fetchCSRFToken();
  }, []);

  const routes = [
    { path: '/', element: <Home />, breadcrumb: 'Home' },
    { path: '/create/shelve', element: <CreateShelf />, breadcrumb: 'Create Shelf' },
    { path: '/create/page', element: <CreatePage />, breadcrumb: 'Create Page' },
    { path: '/:id/:slug', element: <ShelvePageList />, breadcrumb: 'Shelve' },
    { path: '/page/content/:page_id/:slug', element: <PageContent />, breadcrumb: 'Page Content' },
    { path: 'edit/:page_id/:slug', element: <EditPage />, breadcrumb: 'Edit Page' },
    { path: '/edit/shelve', element: <EditShelve />, breadcrumb: 'Page Content' },
    { path: '/tag/pages/:tag_id', element: <TagPages />, breadcrumb: 'Tag Content' },
  ];

  if (!isCSRFTokenLoaded) return <GlobalSpinner/>; // Display loading while token is being fetched

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        theme="colored"
        transition={Slide}
      />

      <Router>
        <BreadcrumbProvider>
          <Routes>
            <Route path="/" element={<StackLayout routes={routes} />}>
              {routes.map((route, index) => (
                <Route key={index} path={route.path} element={route.element} />
              ))}
            </Route>
            {/* <Route path='/test' element={<Test />} /> */}
            <Route path='/sign-in' element={<Login />} />
          </Routes>
        </BreadcrumbProvider>
      </Router>
    </>
  );
}

export default App;
